/* @ngInject */
function TaskListItemController ($scope, $translate, $element, $timeout, $q, UdsModalService, UserService, TasksService) {
  const getRequestDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/request-details/request-details-dialog.controller'))
  const getSubtaskDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/subtask-details/subtask-details-dialog.controller'))
  $scope.today = new Date().toISOString()
  // $scope.viewMode = $scope.viewMode ? $scope.viewMode : 'TASK'

  const api = {
    getRequestDetailsDialogController,
    getSubtaskDetailsDialogController,
    _initTooltip
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._initTooltip()
  }

  $scope.openTaskDialog = (task) => {
    if (task?.originType !== 'SUBTASK') {
      $scope.openTaskDetailDialog(task.id)
      return
    }
    $scope.openSubtaskModal(task)
  }

  $scope.openSubtaskModal = (subtask) => {
    TasksService.getTaskById(subtask.id).then((task) => {
      const subtask = task

      api.getSubtaskDetailsDialogController().then(({ SubtaskDetailsDialogController }) => {
        const modal = UdsModalService.createModal({
          controller: SubtaskDetailsDialogController,
          modalName: 'subtaskDetailsDialog',
          data: {
            subtask
          }
        })
        modal.open()
      })
    })
  }

  $scope.openTaskDetailDialog = (id) => {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        },
        onClose: (data) => {
          if (data?.updatedFields?.title?.updated) {
            $scope.task.title = data.updatedFields.title.newValue
          }
          if (data?.updatedFields?.priority?.updated) {
            $scope.task.priority = data.updatedFields.priority.newValue
          }
          if (data?.updatedFields?.deliveryDate?.updated) {
            $scope.task.deliveryDate = data.updatedFields.deliveryDate.newValue
          }
          if (data?.updatedFields?.assignees?.updated) {
            $scope.task.assignees = data.updatedFields.assignees.newValue
          }
          if (data?.updatedFields?.status?.updated) {
            $scope.task.status = data.updatedFields.status.newValue
          }
          if (data?.attachmentsCount !== undefined && $scope.task.attachments) {
            $scope.task.attachments.count = data.attachmentsCount
          }
          if ($scope.task.attachments !== undefined) {
            $scope.task.attachments.hasUnreadAttachments = false
          }
          if ($scope.task.comments && data) {
            $scope.task.comments.count = data.commentsCount
          }
          $scope.task.unread_comments = false
          $scope.lastRefreshedAt = new Date().getTime()
        }
      })
      modal.open()
    })
  }

  $scope.getTaskIcon = (task) => {
    if (task.originType === 'TASK') return 'tasks'

    if (task.originType === 'SUBTASK') return 'subtask'

    return task.author?.role === 'USER' ? 'workflow' : 'clipboard'
  }

  $scope.getAvatarUrl = (user) => {
    if (!user || !user.id) return null
    return UserService.getUserProfileImage(user.id)
  }

  $scope.getCreationTooltip = (date) => {
    const text = $translate.instant('createdIn')

    const momentDate = moment(date)
    const formattedDate = momentDate.format('L')
    const hour = momentDate.format('HH:mm')

    return `${text}: ${formattedDate} - ${hour}`
  }

  $scope.getAssigneesTooltip = (assignees) => {
    if (!assignees?.length) return

    let text = ''

    assignees.forEach((assignee, index) => {
      text += `${assignee.name}<br>`
    })

    return text
  }

  $scope.setInfoIconColor = (type, task) => {
    const types = {
      attachments: () => {
        if (task.attachments?.hasUnreadAttachments) {
          return 'feedbackColorRedPure'
        }

        return task.attachments?.count ? 'neutralColorLowMedium' : 'neutralColorLowLight'
      },
      comments: () => {
        if (task.unread_comments) {
          return 'feedbackColorRedPure'
        }

        return task.comments?.count ? 'neutralColorLowMedium' : 'neutralColorLowLight'
      }
    }

    const getColorsByTaskType = types[type]

    if (getColorsByTaskType) {
      return getColorsByTaskType()
    }

    const isDeliveryDateLessThanToday = task?.deliveryDate < $scope.today
    const isNotArchived = !task.isArchived

    if (isDeliveryDateLessThanToday && isNotArchived) {
      return 'feedbackColorRedPure'
    }

    if (task.deliveryDate) {
      return 'neutralColorLowMedium'
    }

    return 'neutralColorLowLight'
  }

  function _initTooltip () {
    $timeout(() => {
      angular.element($element).find('.task-list-item .tooltip').popup({
        delay: {
          show: 1000,
          hide: 0
        }
      })
    }, 250, false)
  }
}

export { TaskListItemController }
